module.exports = __webpack_public_path__ + "static/media/promptIcon.cc99cd1a.svg";